<template #default>
  <div class="d-flex flex-wrap justify-space-around"
       style="align-content: flex-start; flex-basis: auto;">

    <div :key="item.id"
         :style="`text-decoration: none; width: ${$vuetify.breakpoint.smAndUp ? '225px' : '100%'};`"
         class="item"
         v-for="item in cardItems">
      <fin-tool-card :height="$vuetify.breakpoint.smAndUp ? '220px' : undefined"
                     :help-center-id="item.helpCenterId"
                     :item-id="item.id"
                     :teaser-text="item.teaserText"
                     :title-text="item.name"
                     :to="item.to"
                     :price-model-feature-id="item.priceModelFeatureId"
                     :tracking="item.tracking"
                     :type-text="item.type"
                     class="mr-2 mb-5"
                     fincraft-verified>
      </fin-tool-card>
    </div>

    </div>
</template>

<script>
import FinToolCard from '../../common/ToolCard'
import PriceModel from "@/mixins/PriceModel"

export default {
  name: 'fin-tools-item',
  components: {
    FinToolCard
  },
  props: {
    items: {
      type: Array
    }
  },
  mixins: [PriceModel],
  computed: {
    cardItems() {
      return this.items.filter(i => {
        return !i.hide && (!i.hideIfFeatureEnabled || (i.hideIfFeatureEnabled && !this.isPriceModelFeatureEnabled(i.priceModelFeatureId)))
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .tagText {
    height: 21px;
    width: 46px;
    left: 211px;
    top: 18px;
    position: absolute;
    background: $fin-color-page-background;
    padding: 3px;
    text-align: center;
    font-size: 12px;
  }
</style>
